// The final reckoning as engine code rather than component code.
//
// This lived inside ScoreBoard.vue's `rows` computed, which was fine while
// the score table was the only thing that needed to know who won. Lifetime
// stats (store/userStats.js) needs the same answer, and two copies of a
// tie-break rule is how a scoreboard and a win counter start disagreeing
// about the same game.
//
// Rulebook p9: most stars wins; a tie on stars is broken by fewest stars
// lost to monsters; still tied, the victory is shared.

/**
 * Every seat's finished-game line, best first.
 *
 * Rows are `{ seat, total, monsters, perSeason, winner }`. `winner` is true
 * for every seat sharing first place, so `rows.filter(r => r.winner).length
 * > 1` is a shared victory.
 */
export const finalStandings = (view) => {
  if (!view?.seasonScores?.length) return [];

  const rows = view.totals.map((total, seat) => ({
    seat,
    total,
    perSeason: view.seasonScores.map((scores) => scores[seat].total),
    monsters: view.seasonScores.reduce((sum, scores) => sum + scores[seat].monsters, 0),
  }));

  const best = Math.max(...rows.map((r) => r.total));
  const leastLost = Math.min(...rows.filter((r) => r.total === best).map((r) => r.monsters));
  rows.forEach((row) => {
    row.winner = row.total === best && row.monsters === leastLost;
  });

  return rows.sort((a, b) => b.total - a.total || a.monsters - b.monsters);
};

/** The seats sharing first place. */
export const winningSeats = (view) => finalStandings(view)
  .filter((row) => row.winner)
  .map((row) => row.seat);
